import { createMutation } from "react-query-kit";
import type { MutationFunction } from "@tanstack/react-query";

import type { IPickMutation } from "../types";
import { getApi } from "../apiPath";
import { axiosClient, queryClient } from "../clients";

import type { IFaculties } from "./routeType";
import { useGetAllFaculties } from "./getAll";
import { useGetFaculty } from "./get";

const { getPath } = getApi("faculties.put");

type IExtractedRouteType = IFaculties["facultySingleUpdate"];

export type IPutFaculty = IPickMutation<IExtractedRouteType>;

const putFaculty: MutationFunction<
  IPutFaculty["response"],
  IPutFaculty["variables"]
> = ({ facultyId, ...data }) => {
  return axiosClient.put(getPath({ facultyId }), data);
};

export const usePutFaculty = createMutation({
  mutationFn: putFaculty,
  onSuccess: (_, { facultyId }) => {
    queryClient.invalidateQueries({ queryKey: useGetAllFaculties.getKey() });
    queryClient.invalidateQueries({
      queryKey: useGetFaculty.getKey({ facultyId }),
    });
  },
});
